import script from "./ComponenteProprietario.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponenteProprietario.vue?vue&type=script&setup=true&lang=js"

import "./ComponenteProprietario.vue?vue&type=style&index=0&id=1247eaf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1247eaf4"]])

export default __exports__